import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { DeepPartial, IListResponse } from '@lib/interfaces';
import {
    IVoucherGenerationRequest,
    IVoucherGenerationResponse,
    IVoucherInquiryRequest,
    IVoucherInquiryResponse,
    IVoucherListRequest,
    IVoucherListResponse,
    IVoucherRedemptionRequest,
    IVoucherRedemptionResponse,
} from '@lib/interfaces/card-less.interface';
import { ICard, ICardStatusChange } from '@lib/interfaces/card.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CardLessService {
    environment_url: string;
    constructor(private http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    public voucherInquiry(payload: IVoucherInquiryRequest): Observable<IVoucherInquiryResponse> {
        return this.http.post<IVoucherInquiryResponse>(`${this.environment_url}nfront/v2/cardless/vouchers/inquiry`, payload);
    }

    public voucherList(params?: IVoucherListRequest) {
        const queryString = new URLSearchParams(params as unknown as Record<string, string>).toString();
        return this.http.get<IVoucherListResponse>(`${this.environment_url}nfront/v2/cardless/vouchers?${queryString}`);
    }

    public generateVoucher(payload: IVoucherGenerationRequest): Observable<IVoucherGenerationResponse> {
        return this.http.post<IVoucherGenerationResponse>(`${this.environment_url}nfront/v2/cardless/vouchers`, payload);
    }

    public redeemVoucher(payload: IVoucherRedemptionRequest, voucher_code: string): Observable<IVoucherRedemptionResponse> {
        return this.http.post<IVoucherRedemptionResponse>(`${this.environment_url}nfront/v2/cardless/vouchers/${voucher_code}/redeems`, payload);
    }

    public qrGenerator(userId: string): Observable<Blob> {
        return this.http.get(`${this.environment_url}nfront/v1/proxy/users/${userId}/details/qr`, {
            responseType: 'blob',
        });
    }

    fetchCardsLazyLoaded(params: URLSearchParams) {
        return this.http.get<IListResponse<ICard>>(`${this.environment_url}nfront/v1/proxy/cards?${params}`);
    }

    public changeCardStatus(id: string, payload: DeepPartial<ICardStatusChange>, isRestrictedStatus = false): Observable<ICard> {
        return this.http.put<ICard>(`${this.environment_url}nfront/v1/proxy/cards/${id}${isRestrictedStatus ? ':changeStatusAdmin' : ':statuschange'}`, payload);
    }
}
